import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, withCtx as _withCtx, mergeProps as _mergeProps } from "vue"

const _hoisted_1 = ["src", "alt"]
const _hoisted_2 = ["textContent"]
const _hoisted_3 = ["disabled"]
const _hoisted_4 = ["disabled"]

export function render(_ctx, _cache) {
  const _component_ListEvent = _resolveComponent("ListEvent")
  const _component_Slide = _resolveComponent("Slide")
  const _component_Carousel = _resolveComponent("Carousel")

  return (_ctx.layout === 'list')
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: _normalizeClass(_ctx.getClass('list-container')),
        ref: "listContainer",
        style: _normalizeStyle(_ctx.styleScrollView)
      }, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.components, (item, pos) => {
          return (_openBlock(), _createBlock(_component_ListEvent, {
            key: pos,
            component: item,
            layout: _ctx.layout,
            structure: _ctx.type,
            settings: _ctx.componentSettings
          }, null, 8 /* PROPS */, ["component", "layout", "structure", "settings"]))
        }), 128 /* KEYED_FRAGMENT */))
      ], 6 /* CLASS, STYLE */))
    : (_openBlock(), _createElementBlock("div", {
        key: 1,
        class: _normalizeClass(_ctx.getClass('carousel-wrapper')),
        ref: "carouselWrapper",
        style: _normalizeStyle(_ctx.styleScrollView)
      }, [
        _createCommentVNode("\n\t\tSD-13645 (feedback round 2): navigation lives on the agent-attribution line - label\n\t\tleft, arrows right - so the controls cost no extra height and can never overlay a card.\n\t\tThe attribution is rendered here rather than by chat.ts (which suppresses its own copy\n\t\tfor carousel messages) so that the label and the arrows share one flex row: the label\n\t\ttakes the remaining width and ellipsises, while the arrow pair keeps its intrinsic size.\n\t\tA long agent name therefore truncates instead of pushing the arrows out of the panel.\n\t\tDeliberately NOT named with \"carousel\" in the class: one client theme wildcards\n\t\t[class*=\"carousel\"] into a 5-column grid, which would break this row.\n\t"),
        (_ctx.showNavRow)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: _normalizeClass(_ctx.getClass('slider-head'))
            }, [
              (_ctx.showSenderDisplay)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 0,
                    class: _normalizeClass(_ctx.getClass('sender-display-container'))
                  }, [
                    (_ctx.showSenderAvatar)
                      ? (_openBlock(), _createElementBlock("img", {
                          key: 0,
                          src: _ctx.senderAvatarUrl,
                          alt: _ctx.senderAvatarAlt,
                          class: _normalizeClass(_ctx.getClass('sender-display-avatar'))
                        }, null, 10 /* CLASS, PROPS */, _hoisted_1))
                      : _createCommentVNode("v-if", true),
                    (_ctx.showSenderName)
                      ? (_openBlock(), _createElementBlock("span", {
                          key: 1,
                          class: _normalizeClass(_ctx.getClass('sender-display-name')),
                          textContent: _toDisplayString(_ctx.senderName)
                        }, null, 10 /* CLASS, PROPS */, _hoisted_2))
                      : _createCommentVNode("v-if", true)
                  ], 2 /* CLASS */))
                : _createCommentVNode("v-if", true),
              (_ctx.showNavButtons)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 1,
                    class: _normalizeClass(_ctx.getClass('slider-nav'))
                  }, [
                    _createCommentVNode(" `disabled` only, no aria-disabled: the native attribute already exposes the state\n\t\t\t     to assistive tech, and it takes the button out of the tab order so an\n\t\t\t     aria-disabled duplicate could never be announced anyway. "),
                    _createElementVNode("button", {
                      type: "button",
                      class: _normalizeClass(_ctx.getClass('slider-nav__btn')),
                      disabled: _ctx.isPrevDisabled,
                      onMousedown: _cache[0] || (_cache[0] = (...args) => (_ctx.onNavMouseDown && _ctx.onNavMouseDown(...args))),
                      onClick: _cache[1] || (_cache[1] = (...args) => (_ctx.navPrev && _ctx.navPrev(...args))),
                      "aria-label": "Previous item"
                    }, _cache[4] || (_cache[4] = [
                      _createElementVNode("svg", {
                        xmlns: "http://www.w3.org/2000/svg",
                        viewBox: "0 0 320 512",
                        "aria-hidden": "true",
                        focusable: "false"
                      }, [
                        _createElementVNode("path", { d: "M9.4 233.4c-12.5 12.5-12.5 32.8 0 45.3l192 192c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L77.3 256 246.6 86.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-192 192z" })
                      ], -1 /* HOISTED */)
                    ]), 42 /* CLASS, PROPS, NEED_HYDRATION */, _hoisted_3),
                    _createElementVNode("button", {
                      type: "button",
                      class: _normalizeClass(_ctx.getClass('slider-nav__btn')),
                      disabled: _ctx.isNextDisabled,
                      onMousedown: _cache[2] || (_cache[2] = (...args) => (_ctx.onNavMouseDown && _ctx.onNavMouseDown(...args))),
                      onClick: _cache[3] || (_cache[3] = (...args) => (_ctx.navNext && _ctx.navNext(...args))),
                      "aria-label": "Next item"
                    }, _cache[5] || (_cache[5] = [
                      _createElementVNode("svg", {
                        xmlns: "http://www.w3.org/2000/svg",
                        viewBox: "0 0 320 512",
                        "aria-hidden": "true",
                        focusable: "false"
                      }, [
                        _createElementVNode("path", { d: "M310.6 233.4c12.5 12.5 12.5 32.8 0 45.3l-192 192c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L242.7 256 73.4 86.6c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l192 192z" })
                      ], -1 /* HOISTED */)
                    ]), 42 /* CLASS, PROPS, NEED_HYDRATION */, _hoisted_4)
                  ], 2 /* CLASS */))
                : _createCommentVNode("v-if", true)
            ], 2 /* CLASS */))
          : _createCommentVNode("v-if", true),
        _createVNode(_component_Carousel, _mergeProps({ "aria-label": "Horizontal content carousel" }, _ctx.carouselSettings, {
          ref: "carouselContainer",
          onInit: _ctx.onMountCarousel,
          onSlideEnd: _ctx.onSlideEnd,
          onDrag: _ctx.onDrag,
          onSlideStart: _ctx.onDrag
        }), {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.components, (item, pos) => {
              return (_openBlock(), _createBlock(_component_Slide, { key: pos }, {
                default: _withCtx(() => [
                  _createVNode(_component_ListEvent, {
                    component: item,
                    layout: _ctx.layout,
                    structure: _ctx.type,
                    settings: _ctx.componentSettings
                  }, null, 8 /* PROPS */, ["component", "layout", "structure", "settings"])
                ]),
                _: 2 /* DYNAMIC */
              }, 1024 /* DYNAMIC_SLOTS */))
            }), 128 /* KEYED_FRAGMENT */))
          ]),
          _: 1 /* STABLE */
        }, 16 /* FULL_PROPS */, ["onInit", "onSlideEnd", "onDrag", "onSlideStart"])
      ], 6 /* CLASS, STYLE */))
}